import { track } from "./tracker";

export const EVENTS = {
	job_viewed: "job.viewed",
	job_applied: "job.applied",
	job_apply_intent: "job.apply_intent",
	course_viewed: "course.viewed",
	course_purchase_intent: "course.purchase_intent",
	course_enroll_intent: "course.enroll_intent",
	assessment_viewed: "assessment.viewed",
	assessment_purchased: "assessment.purchased",
	assessment_opened: "assessment.opened",
	section_viewed: "section.viewed",
	section_dwell: "section.dwell",
	topcard_selected: "topcard.selected",
};

export function trackEvent(eventKey, data = {}) {
	const name = EVENTS[eventKey];
	if (!name) {
		console.warn(`[tracking] trackEvent: unknown event key "${eventKey}"`);
		return;
	}
	track(name, data);
}
